import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export const SEARCH_ORIGIN_QUERY_PARAM = 'origin';

export const ANALYTICS_CATEGORIES = {
  WHILE_YOU_WAIT: 'v2-while-you-wait'
};

// Consumed only as AnalyticsContext's contextName. SearchAnalyticsContext is an unrelated
// React context, not a value from here.
export const ANALYTICS_CONTEXTS = {
  BIB: 'bib'
};

export default createReduxConstants('ANALYTICS', {
  FETCH_DATALAYER_REQUEST: null,
  FETCH_DATALAYER_SUCCESS: null,
  FETCH_DATALAYER_FAILURE: null,
  SET_CONTEXT: null
});
